import { render, staticRenderFns } from "./CompanyProfileOtherSettings.vue?vue&type=template&id=066cec4c&scoped=true&"
import script from "./CompanyProfileOtherSettings.vue?vue&type=script&lang=js&"
export * from "./CompanyProfileOtherSettings.vue?vue&type=script&lang=js&"
import style0 from "./CompanyProfileOtherSettings.vue?vue&type=style&index=0&id=066cec4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066cec4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VCol,VDivider,VProgressCircular,VRow,VSnackbar})
